export var eventRoute = function eventRoute(_config, data) {
  if (!data.route) {
    return null;
  }
  return {
    'event:route': data.route
  };
};